import { Eye, EyeOff, Settings2 } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IndustryManager = ({ role }) => {
  const [industries, setIndustries] = useState([]);
  const [busySlug, setBusySlug] = useState("");
  useEffect(() => {
    if (role !== "admin") return;
    fetch(`${API}/admin/industries`, { credentials: "include" })
      .then((response) => response.ok ? response.json() : [])
      .then(setIndustries)
      .catch(() => toast.error("Unable to load industry settings."));
  }, [role]);
  if (role !== "admin") return null;
  const toggle = async (industry) => {
    setBusySlug(industry.slug);
    try {
      const response = await fetch(`${API}/admin/industries/${industry.slug}`, { method: "PATCH", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ active: !industry.active }) });
      const updated = await response.json();
      if (!response.ok) throw new Error(updated.detail || "Unable to save industry visibility.");
      setIndustries((current) => current.map((item) => item.slug === updated.slug ? updated : item));
      toast.success(`${updated.name} is now ${updated.active ? "visible" : "hidden"} publicly.`);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBusySlug("");
    }
  };
  return <section className="industry-manager" data-testid="industry-manager"><div className="industry-manager-title"><Settings2 size={19} /><div><p className="eyebrow">PUBLIC WEBSITE SETTINGS</p><h2>INDUSTRY VISIBILITY</h2></div></div><p className="industry-manager-copy">Turn off an industry to hide it from public cards, industry listings, and all job-seeker and employer selections.</p><div className="industry-manager-grid">{industries.map((industry) => <article key={industry.slug} className={!industry.active ? "is-hidden" : ""} data-testid={`industry-visibility-${industry.slug}`}><span>{industry.name}</span><button type="button" disabled={busySlug === industry.slug} onClick={() => toggle(industry)} data-testid={`industry-toggle-${industry.slug}`}>{industry.active ? <><Eye size={15} /> Public</> : <><EyeOff size={15} /> Hidden</>}</button></article>)}</div></section>;
};